export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14670.ba6d557c.jpg";